export default __webpack_public_path__ + "static/media/affiliate-suomen_jujutsuliitto.ea825117.png";